
import { Link } from "react-router-dom";
import Logo from "@/components/common/Logo";

const PricingFooter = () => {
  return (
    <footer className="py-8 border-t border-border">
      <div className="container mx-auto px-4">
        <div className="flex flex-col md:flex-row justify-between items-center">
          <Link to="/">
            <Logo size="small" />
          </Link>
          <div className="mt-4 md:mt-0 text-muted-foreground text-sm">
            © {new Date().getFullYear()} Go Dyspo. All rights reserved.
          </div>
        </div>
      </div>
    </footer>
  );
};

export default PricingFooter;
